var _path, _rect, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRespIllustrationFaq(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 204,
    viewBox: "0 0 70 204",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 0L50 0V192.5C50 198.851 44.8513 204 38.5 204C32.1487 204 27 198.851 27 192.5V0Z",
    fill: "#E29578"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 170.366,
    y: 107.53,
    width: 37.5893,
    height: 170.366,
    rx: 18.7946,
    transform: "rotate(90 170.366 107.53)",
    fill: "#005B7F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 202.153,
    y: 95,
    width: 25.0595,
    height: 170.366,
    rx: 12.5298,
    transform: "rotate(90 202.153 95)",
    fill: "#679ACB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 218.226,
    y: 132.981,
    width: 24.2764,
    height: 170.723,
    rx: 12.1382,
    transform: "rotate(90 218.226 132.981)",
    fill: "#FFDDD2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRespIllustrationFaq);
export default __webpack_public_path__ + "static/media/Resp_IllustrationFAQ.30c652256ea4b533a08a9b9a1e1e3dcf.svg";
export { ForwardRef as ReactComponent };